export default "__VITE_ASSET__CorK5hui__"